import Search from './components/search/Search'
import './scripts.js'

document.addEventListener("DOMContentLoaded", () => new Search('headerSearch'));
